export default __webpack_public_path__ + "static/media/panel-bkg-2x.54714a03.png";